import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "topic-category" }
const _hoisted_2 = { class: "topic" }
const _hoisted_3 = { class: "category" }
const _hoisted_4 = { class: "question-number" }
const _hoisted_5 = { class: "navigation" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "controls" }

import {ref, watch} from "vue"
import TextQuestion from "@/components/question/impl/TextQuestion.vue";
import NumericQuestion from "@/components/question/impl/NumericQuestion.vue";
import ChoiceQuestion from "@/components/question/impl/ChoiceQuestion.vue";
import MultipleChoiceQuestion from "@/components/question/impl/MultipleChoiceQuestion.vue";
import DateQuestion from "@/components/question/impl/DateQuestion.vue";
import {QuestionEntry, QuestionType, RawAnswer} from "@/lib/QuestionHandler";


export default /*#__PURE__*/_defineComponent({
  __name: 'QuestionComponent',
  props: {
    question: {},
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit: __emit }) {

const componentMapping = {
  [QuestionType.TYPE_TEXT]: TextQuestion,
  [QuestionType.TYPE_NUMERIC]: NumericQuestion,
  [QuestionType.TYPE_CHOICE]: ChoiceQuestion,
  [QuestionType.TYPE_MULTIPLE_CHOICE]: MultipleChoiceQuestion,
  [QuestionType.TYPE_DATE]: DateQuestion,
}

const emit = __emit

const props = __props

const value = ref<RawAnswer>(props.modelValue)

watch(value, () => {
  emit('update:modelValue', value.value)
}, { immediate: true, deep: true })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`question-component type-${_ctx.question.type}`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.question.topic.name), 1),
      _createElementVNode("span", _hoisted_3, "/" + _toDisplayString(_ctx.question.category.name), 1)
    ]),
    _createElementVNode("div", _hoisted_4, " Frage Nr. " + _toDisplayString(_ctx.question.numberString), 1),
    _createElementVNode("div", _hoisted_5, [
      _renderSlot(_ctx.$slots, "navigation")
    ]),
    _createElementVNode("div", {
      class: "question",
      innerHTML: _ctx.question.question
    }, null, 8, _hoisted_6),
    (_ctx.question.addOns)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.question.addOns, (addOn) => {
          return (_openBlock(), _createElementBlock("ul", {
            class: "addons",
            key: addOn.id
          }, [
            _createElementVNode("li", {
              innerHTML: addOn.value
            }, null, 8, _hoisted_7)
          ]))
        }), 128))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(componentMapping[_ctx.question.type]), {
        question: _ctx.question,
        modelValue: value.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((value).value = $event)),
        class: _normalizeClass({ disabled: !_ctx.question.displayed })
      }, null, 8, ["question", "modelValue", "class"]))
    ])
  ], 2))
}
}

})